<template>
  <div>
    <div class="">
      <SectionHeader>
        <template #left>
          <h2>Postbacks</h2>
        </template>
        <template #right>
          <Modal>
            <template #default="{toggle}">
              <button
                v-tooltip="`Add Account Level Postback`"
                @click="toggle"
                class="p-2 rounded-full cursor-pointer text-base-content/20 hover:text-accent hover:scale-110 shadow-none transition transform duration-500 ease-in-out"
              >
                <v-icon name="hi-document-add" scale="1.5" class="cursor-pointer" />
              </button>
            </template>
            <template #modal="{close}">
                <CreatePostbackPanel 
                    class="w-full" 
                    @close="close"
                />
            </template>
          </Modal>
        </template>
      </SectionHeader>
      <XTable :data="postbacks || []">
        <template v-slot:header-row>
          <th>Target</th>
          <th>Url</th>
          <th></th>
        </template>
        <template v-slot:row="props">
          <td>

            <template v-if="props.row.redirect">
            <template v-if="props.row.redirect.campaign">
              <div class="flex flex-wrap items-center gap-4">
                  <img 
                    v-if="getFirstImage(props.row.redirect.campaign.images ?? [])" 
                    class="w-12 h-10 rounded-md object-contain" 
                    :src="getFirstImage(props.row.redirect.campaign.images ?? [])" 
                  />
                  <router-link
                  :to="{
                    name: 'Campaign',
                    params: { id: props.row.redirect.campaign.id }
                  }"
                  class="link-primary"
                >
                  {{ props.row.redirect.campaign.name }}
                </router-link>
                <span class="text-xs text-base-content/30"
                  >{{ props.row.redirect.campaign.id }}</span>
              </div>
            </template>
            <template v-else>
              {{ props.row.redirect.id }} -
              {{ props.row.redirect.subdomain }}.{{
                props.row.redirect.domain
              }}
            </template>
          </template>
          <template v-else
            >
            <span class="text-base-content"
              >Account Level Postback</span
            >                <v-icon
                    name="bi-info-circle"
                    class="text-primary ml-2"
                    v-tooltip="`Account Level Postbacks fire conversions on campaigns when no Campaign
      Level Postback is set.`"
                />
            </template
          >
          </td>
          <td style="white-space: normal;">{{ props.row.fullUrl }}</td>
          <td class="text-right">
            <div class="flex justify-end">
                                    <Modal>
                                        <template #default="{toggle}">
                                            <a
                                                v-tooltip="`Edit`"
                                                href="#"
                                                class="link text-base-content/50 hover:text-base-content p-1"
                                                @click.prevent="toggle"
                                                >
                                                <v-icon name="la-edit-solid" />
                                                </a>
                                        </template>
                                        <template #modal="{close}">
                                            <UpdatePostbackPanel 
                                                class="w-full" 
                                                :id="props.row.id" 
                                                @close="close"
                                            />
                                        </template>
                                    </Modal>


                                    <Modal>
                                        <template #default="{toggle}">
                                            <a
                                                v-tooltip="`Delete`"
                                                href="#"
                                                class="text-base-content/50 hover:text-red-600 p-1"
                                                @click.prevent="
                                                    toggle
                                                "
                                                >
                                                <v-icon name="io-close" />
                                            </a>
                                        </template>
                                        <template #modal="{close}">
                                            <DeletePostbackPanel 
                                                class="w-full" 
                                                :postback="props.row" 
                                                @close="close"
                                            />
                                        </template>
                                    </Modal>
     
                                </div>
          </td>
        </template>
      </XTable>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue"
import { useAuthStore } from "@/stores/auth.js"
import { useQuery } from "@vue/apollo-composable"
import { useRouter } from "vue-router"
import Modal from '@/components/common/Modal.vue'
import SectionHeader from '@/components/common/SectionHeader.vue'
import CreatePostbackPanel from '@/pages/postbacks/CreatePostbackPanel.vue'
import UpdatePostbackPanel from '@/pages/postbacks/UpdatePostbackPanel.vue'
import DeletePostbackPanel from '@/pages/postbacks/DeletePostbackPanel.vue'

import { useImageWithConversions } from "@/composables/useImageWithConversions.js"

import POSTBACKS_QUERY from "@/graphql/Postback/Postbacks.gql"

const router = useRouter()
const authStore = useAuthStore()
const postbacks = ref("")

const { getFirstImage } = useImageWithConversions()

const variables = computed(() => ({
  publisherId: authStore?.authUser?.id,
  filters: {
    userId: { value: authStore?.authUser?.id },
    onlyParents: true,
  },
  first: 1000,
  orderBy: [
    {
      column: "user_id",
      order: "ASC",
    },
    {
      column: "redirect_id",
      order: "ASC",
    },
  ],
}))
const { onResult: onPostbacks } = useQuery(POSTBACKS_QUERY, variables, {enabled: authStore.authUser})

onPostbacks(queryResult => {
  if (queryResult.data !== undefined) {
    postbacks.value = queryResult.data.postbacks.data
  }
})

</script>
